// extracted by mini-css-extract-plugin
module.exports = {"mobile":"768px","tablet":"967px","laptop":"1200px","desktop":"1512px","xl":"1800px","themeTransitionDuration":".4s"};